module.exports = __webpack_public_path__ + "static/img/门诊保健应用.2520da2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/门诊保健应用.png
// module id = 24qr
// module chunks = 1